<template>
  <div class="gift-card-item">
    <div class="gift-card-item__image">
      <img
        :src="giftCardImageUrl"
        alt="ギフトカード画像"
        class="gift-card-item__image--gift-card-image"
      />
    </div>
    <div class="gift-card-item__content">
      <p class="gift-card-item__content--sender-name">
        贈り主名：{{ senderName }}
      </p>
      <div v-if="hasMessage" class="gift-card-item__content--message-wrapper">
        <p class="gift-card-item__content--message">
          {{ message }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  giftCardImageUrl: {
    type: String,
    required: true
  },
  senderName: {
    type: String,
    required: true
  },
  message: {
    type: String,
    required: false,
    default: ''
  }
})

const hasMessage = computed(() => props.message.trim() !== '')
</script>
<style lang="scss" scoped>
.gift-card-item {
  display: flex;
  background-color: $white;
  height: 82px;
  width: 100%;
  gap: 16px;

  &__image {
    &--gift-card-image {
      width: 82px;
      height: 82px;
      object-fit: contain;
      border-radius: 8px;
    }
  }

  &__content {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    flex: 1;
    gap: 4px;

    &--sender-name {
      font-size: 1rem;
      line-height: 1.6;
      color: $black;
    }

    &--message-wrapper {
      padding: 10px;
      box-sizing: border-box;
      background-color: $gray-3;
      border-radius: 8px;
      flex: 1;
      width: 100%;
    }

    &--message {
      font-size: 1rem;
      line-height: 1.6;
      color: $black;
      text-align: left;
      display: -webkit-box;
      overflow-y: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      line-clamp: 3;
    }
  }
}
</style>
